<template lang="pug">
div
  app-imovel-area-permutada(
    :imovel="cadastro.imovel"
  )
  app-imovel-area-interesse(
    :imovel="cadastro.imovel"
  )
  app-documentos(
    v-if="inputsExtraCadastro.imovel.escrituraDocumentoRegistro"
    :maxSize='25',
    :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
    :documentos="cadastro.imovel.documentos"
    :tiposDocumentos="documentos"
    :tiposDocumentosObrigatorios="documentosObrigatorio"
    :observer="observer",
    aba="Interessado"
  )
</template>

<script>
import { mapActions } from 'vuex'
import AppImovelAreaPermutada from '../../../../components/cadastro/AppImovelAreaPermutada'
import AppImovelAreaInteresse from '../../../../components/cadastro/AppImovelAreaInteresse'
import AppDocumentos from '../../../../components/cadastro/AppDocumentos'
const {inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {
  components: {
    AppImovelAreaPermutada,
    AppImovelAreaInteresse,
    AppDocumentos
  },

  props: ['cadastro', 'observer'],

  data () {
    return {
      inputsExtraCadastro,
      documentos: [],
      documentosObrigatorio: []
    }
  },

  async beforeRouteLeave (to, from, next) {
    if (inputsExtraCadastro.imovel.escrituraDocumentoRegistro) {
      this.documentos = await this.findDocumentos('imovelPermuta')
      this.documentosObrigatorio = await this.findDocumentos('obrigatorio/imovelPermuta')
      await this.observer.validate({ providerName: 'Imóvel/Documentos', skipIfEmpty: false })
    }
    next()
  },

  async created () {
    if (inputsExtraCadastro.imovel.escrituraDocumentoRegistro) {
      this.documentos = await this.findDocumentos('imovelPermuta')
      this.documentosObrigatorio = await this.findDocumentos('obrigatorio/imovelPermuta')
    }
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    })
  }

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/permuta/components/Imovel.vue